import { render, staticRenderFns } from "./MediaFolderList.vue?vue&type=template&id=1b464c88&scoped=true"
import script from "./MediaFolderList.vue?vue&type=script&lang=js"
export * from "./MediaFolderList.vue?vue&type=script&lang=js"
import style0 from "./MediaFolderList.vue?vue&type=style&index=0&id=1b464c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b464c88",
  null
  
)

export default component.exports